import { HttpErrorResponse } from '@angular/common/http';
import { Action, createReducer, on } from '@ngrx/store';

import { ParticipantsFailure, ParticipantsRequest, ParticipantsSuccess } from './actions';
import { ClientPolicyParticipants } from '@models/swagger';

export const featureKey = 'participants';

export interface State {
  data: ClientPolicyParticipants[] | null;
  error: HttpErrorResponse | null;
  loading: boolean;
}

export const initialState: State = {
  data: [],
  error: null,
  loading: null,
};

export function reducer(state: State | undefined, action: Action) {
  return createReducer(
    initialState,
    on(ParticipantsFailure, (state, { error }) => ({ ...state, data: [], error, loading: false })),
    on(ParticipantsRequest, state => ({ ...state, error: null, loading: true })),
    on(ParticipantsSuccess, (state, { data }) => ({ ...state, data, error: null, loading: false }))
  )(state, action);
}
